import { get_page_context } from '../context.ts';
import { format_long } from '../intl/number.ts';

import Page from '../components/Page.tsx';

export interface WelcomePageProps {}

export function WelcomePage({}: WelcomePageProps) {
	const ctx = get_page_context();

	const posts = ctx.records.posts;

	let root_amount = 0;
	let replies_amount = 0;
	{
		for (const post of posts.values()) {
			if (post.reply === undefined) {
				root_amount++;
			} else {
				replies_amount++;
			}
		}
	}

	return (
		<Page title={`@${ctx.profile.handle}'s Bluesky archive`}>
			<div class="WelcomePage__content">
				<h1 class="WelcomePage__header">Welcome to @{ctx.profile.handle}'s Bluesky archive</h1>
				<p class="WelcomePage__paragraph">
					There are {format_long(posts.size)} posts in this archive, containing {format_long(root_amount)}{' '}
					roots and {format_long(replies_amount)} replies. Use the links at the top to navigate the archive.
				</p>
			</div>
			<div class="WelcomePage__footer">
				generated by{' '}
				<a href="https://mary-ext.github.io/skeetgen" target="_blank" class="Link">
					skeetgen
				</a>{' '}
				at {new Date().toISOString()}
			</div>
		</Page>
	);
}
